export default "__VITE_ASSET__ChVuYwTB__"